<template>
  <div class="pa-2">
    <span class="heading mb-2">Dealer Page</span>
     <v-btn
      depressed
      @click="showCommentBox"
      color="primary"
    >
      Add Company
    </v-btn>

    <v-data-table :headers="headers" :items="companyList" v-on:click:row="rowClickHandler">
     <template v-slot:item.actions="{ item }">
      <v-btn small class="mr-4" v-on:click="inviteHandler(item)"
        >Invite Dealer</v-btn
      >
     
    </template>
    </v-data-table>

    <v-dialog
      v-model="companyDialog"
      width="500"
        height="100%"
    >
    <v-card>
      <v-form
      style="padding:5px"
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-text-field
      v-model="name"
      :counter="10"
      label="Name"
    ></v-text-field>

    <v-text-field
      v-model="add_line_1"
      label="Address One"
    ></v-text-field>
     <v-text-field
      v-model="add_line_2"
      label="Address Two"
      
    ></v-text-field>
     <v-text-field
      v-model="city"
      label="City"
    ></v-text-field>
     <v-text-field
      v-model="state"
      label="State"
    ></v-text-field>
<v-text-field
      v-model="zip"
      label="Zip"
    ></v-text-field>
    
    

    <v-btn
      color="success"
      class="mr-4"
      @click="companyCreateHandle"
    >
      Add Company
    </v-btn>

   
  </v-form>
    </v-card>
    </v-dialog>



     <v-dialog
      v-model="inviteDialog"
      width="500"
        height="100%"
    >
    <v-card>
      <v-form
      style="padding:5px"
    ref="form"
    v-model="isinvite"
    lazy-validation
  >
    <v-row>
    <v-text-field
      v-model="inviteEmail"
      class="col-md-8"
      :counter="10"
      label="Email"
      @keyup.13="onEnterClick"
    ></v-text-field>
<v-icon  class="col-md-4" @click="onEnterClick">mdi-plus</v-icon>
    </v-row>
    <ul>
    <li v-for="item in emails">{{ item }}</li>
  </ul>
    <v-text-field
      v-model="inviteAdd1"
      label="Address One"
      style="display: none"
    ></v-text-field>
    
    <v-btn
      color="success"
      class="mr-4"
      @click="inviteHandle"
    >
      Send Invite
    </v-btn>

   
  </v-form>
    </v-card>
    </v-dialog>
    
  </div>
</template>

<script>
import { userApi} from "@/api";
import { mapActions } from "vuex";

export default {
  components: {

  },
  data() {
    return {
      emails:[],
      companyDialog: false,
      inviteDialog:false,
      valid: true,
      isinvite:true,
inviteName:"",
inviteAdd1:"",
inviteAdd2:"",
inviteCity:"",
inviteState:"",
inviteZip:"",
invitePhone:"",
inviteDealerId:null,
inviteEmail:"",
     name:'',
     add_line_1:'',
     add_line_2:'',
     city:'',
     state:'',
     zip:'',
     companyList:[],
     headers: [
          {
            text: 'Id',
            value: 'id',
          },
          { text: 'Name', value: 'name' },
            { text: "Actions", value: "actions", sortable: false },
        ]
     
    };
  },
  computed: {
      
  },
  created() {
 this.loadCompaniesData();
  },
  methods: {
     ...mapActions(["toggleCollaboratorsModal"]),
    showCommentBox(){
     this.companyDialog=true;
   },
   onEnterClick() {
     if(this.inviteEmail!="")
     {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.inviteEmail)) {
       this.emails.push(this.inviteEmail);
    } else {
         
          this.$toast.error("invalid email");
    }
      
       
     }
       
    },
    loadCompaniesData(){
      let loader = this.$loading.show();
      userApi
      .getCompanies()
      .then(({ data }) => {
      this.companyList=data.dealers
       loader.hide();
        console.log("companies data",this.companyList);
      })
    },
    inviteHandler(data) {
      this.inviteDealerId=data.id;
      this.inviteDialog=true;
    },
   addCompany(){
      console.log("COMPANY DETAILS",this.name); 
   }
    ,
    async companyCreateHandle() {
     
        let loader = this.$loading.show();
        try {
            let companyDetails={
                "name":this.name,
                 "address":{
                 "add_line_1":this.add_line_1,
                "add_line_2":this.add_line_2,
                "city":this.city,
                 "state":this.state,
                 "zip":this.zip
                 }
            } 
          const addCompany = await userApi.createCompany({
            ...companyDetails
          });
          loader.hide();
         
          this.$toast.success("Project is created successfully.");
          this.loadCompaniesData();
          this.companyDialog=false;
        } catch (error) {
          loader.hide();
          this.$toast.error(error.response.data.message);
        }
      
    },
  async inviteHandle() {
     
        
        try {
          let loader = this.$loading.show();
          if(this.emails.length>0)
          {
            for(let i=0;i<this.emails.length;i++)
            {
             await this.sendInvite(this.emails[i]);
            }

          }
          else{
            this.sendInvite(this.inviteEmail)
          }
            
          loader.hide();
        } catch (error) {
          loader.hide();
          this.$toast.error("unable to process request");
        }
      
    },
    async sendInvite(email){
      try{
      
      let inviteDetails={
              "email":email,
                "name":this.inviteName,
                 "address":{
                 "add_line_1":this.inviteAdd1,
                "add_line_2":this.inviteAdd2,
                "city":this.inviteCity,
                 "state":this.inviteState,
                 "zip":this.inviteZip,
                 "phone":this.invitePhone,
                 },
                 dealerId:this.inviteDealerId
            } 
          const inviteDealer = await userApi.inviteDealer({
            ...inviteDetails
          });
          this.$toast.success("Invite sent successfully to "+email);
          if(inviteDealer.status==201)
          {
          
          }
          else{
             this.$toast.error("unable to send invite to "+email);
          }
        this.inviteDialog=false;
        return true;
      }
      catch (error) {
          
          this.$toast.error("unable to send invite to "+email);
          return false;
        }
    
    },
    async handleDeleteBtnClick(item) {
      if (confirm("Are you sure you want to delete?")) {

        item=JSON.parse(JSON.stringify(item));
     let { email } = this.$store.getters.authUser;
      let projectId=item.projectName+'+'+item.createdBy;
      let scheduleId=item.scheduleName;

        let loader = this.$loading.show();
        try {

          scheduleApi
      .deleteSchedule({
          projectId,
          scheduleId,
          email
        })
      .then(({ data }) => {
        loader.hide();
        this.$toast.success("Schedule is deleted successfully.");


      })
      .catch((error) => {
        loader.hide();
        console.log(error);
      });

        } catch (error) {
          loader.hide();
          this.$toast.error(error.response.data.message);
        }
      }
    },
    async handleDeleteInviteBtnClick(item) {
       item=JSON.parse(JSON.stringify(item));
      if (confirm("Are you sure you want to delete?")) {


     let  email  = item.user.email;
      let projectId=this.selectedSchedule.projectName+'+'+this.selectedSchedule.createdBy;
      let scheduleId=this.selectedSchedule.scheduleName;

        let loader = this.$loading.show();
        try {

          scheduleApi
      .deleteSchedule({
          projectId,
          scheduleId,
          email
        })
      .then(({ data }) => {
        loader.hide();
        this.$toast.success("deleted successfully.");


      })
      .catch((error) => {
        loader.hide();
        console.log(error);
      });
          
        } catch (error) {
          loader.hide();
          this.$toast.error(error.response.data.message);
        }
      }
    },
    handleInviteCollabBtnClick() {
      this.createInvite.dialog = true;
    },
    

  },
};
</script>

<style>
.heading {
  font-size: 18pt;
  display: block;
}

.modal-lg {
    max-width: 1000px !important;
    width:1000px !important;
   }


  .modal-dialog {
    max-width: 1000px !important;
width:1000px !important;
  }

</style>
